<template>
  <v-alert class="my-6" outlined type="info" color="primary">
    {{ message }}
  </v-alert>
</template>

<script>
export default {
  name: 'InfoAlert',
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>
